import { render, staticRenderFns } from "./ConsultationSingle.vue?vue&type=template&id=4ea72758"
import script from "./ConsultationSingle.vue?vue&type=script&lang=js"
export * from "./ConsultationSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports